export default "__VITE_ASSET__CUra1IDu__"